import React, { useEffect, useRef } from 'react'
import { Chip, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import DishesCard from '../../../components/user/dishesCard';
import { useSelector } from 'react-redux';
import { getCurDate } from '../../../utils/common';

const LUNCH = 'lunch'

const dayKey = (row) => {
  const raw = `${row?.formatDate || ''}`
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10)

  const label = `${row?.date || ''}`.match(/(\d{2})-(\d{2})-(\d{4})/)
  if (label) return `${label[3]}-${label[2]}-${label[1]}`

  const slashed = raw.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/)
  if (slashed) return `${slashed[3]}-${slashed[2]}-${slashed[1]}`

  return ''
}

const buildTodayChip = (formatDate) => {
  const [y, m, d] = formatDate.split('-')
  const day = new Date(+y, +m - 1, +d)
  const weekday = day.toLocaleDateString('en-US', { weekday: 'long' })

  return { nID: 'cutoff-today', date: `${weekday} (${d}-${m}-${y})`, formatDate }
}

const isCutoffDish = (dish, cutoff) => {
  if (cutoff.MenuId) return +dish.nID === +cutoff.MenuId

  const itemName = `${cutoff.MenuItemName || ''}`.trim().toLowerCase()
  if (!itemName) return false

  const menuName = Array.isArray(dish.cMenuName) ? dish.cMenuName[0] : dish.cMenuName

  return `${dish.cMenuDesc || ''}`.trim().toLowerCase() === itemName
    || `${menuName || ''}`.trim().toLowerCase() === itemName
}

const Dishes = ({ setOrderCount, activeCateg, orderCount, products, value, setValue}) => {

  const { UserHomeReducers: { mealMenuList, daysOfWeek, todayOrderDate, categoryList, activeCutoffLunch, vendorId } } = useSelector(state => state)
  const tempinitsform = useRef();
  const tempcutoffform = useRef();

  const handleChange = (name) => {
    setValue(name);
  };

  const today = getCurDate()

  const isLunch = `${categoryList.find((c) => +c.nID === +activeCateg)?.cMealName || ''}`
    .trim()
    .toLowerCase()
    .includes(LUNCH)

  // Today's cutoff for the category on screen: one set up for the chosen vendor,
  // whose menu is of this meal (a cutoff without MealId is treated as lunch, as
  // before) and whose end time hasn't passed yet
  const now = new Date().toTimeString().slice(0, 5)
  const forVendor = (c) => `${c.VendorIds || ''}`.split(',').some((id) => +id === +vendorId)
  const stillOpen = (c) => !c.EndTime || now <= c.EndTime
  const cutoff = (activeCutoffLunch || []).find((c) =>
    forVendor(c) && stillOpen(c) && (c.MealId ? +c.MealId === +activeCateg : (isLunch || activeCateg === 7))
  ) || null

  const isTodayList = !!cutoff
  const baseDays = (daysOfWeek || []).filter((d) => dayKey(d) !== today)

  const lunchDays = () => {
    if (!isTodayList || !cutoff) return baseDays

    const todayRow = (todayOrderDate || []).find((d) => dayKey(d) === today)

    return [todayRow || buildTodayChip(today), ...baseDays.slice(0, -1)]
  }

  const dayList = lunchDays()

  const initsform = () => {
    daysOfWeek.length && setValue(daysOfWeek[0])
  };

  tempinitsform.current = initsform;

  useEffect(() => {
    tempinitsform.current();
  }, [daysOfWeek]);

  // Start on the first day that can be ordered: today while a cutoff is open,
  // otherwise tomorrow. Re-applied when the category, vendor or cutoff changes.
  const selectFirstDay = () => {
    if (!dayList.length) return
    setValue(dayList[0])
  };

  tempcutoffform.current = selectFirstDay;

  useEffect(() => {
    tempcutoffform.current();
  }, [dayList.map(dayKey).join(','), activeCateg, vendorId]);

  const showCutoffOnly = isTodayList && cutoff && dayKey(value) === today

  const dishList = showCutoffOnly
    ? mealMenuList.filter((d) => isCutoffDish(d, cutoff))
    : mealMenuList

  return (
    <Box mt='44px'>

      <Grid container spacing={2} justifyContent='center' >

        {dayList.map((d) => (
          <Grid item key={d.nID} >
            {/* Matched on the date: the two day lists reuse nID 1..7 for different days */}
            <Chip onClick={() => handleChange(d)} color={dayKey(value) === dayKey(d) ? 'primary' : 'default'} sx={{ height:40 }} label={
              <Typography variant='t12_500'>
                {d.date}
              </Typography>
            } />

          </Grid>
        ))}
      </Grid>

      {dishList.length ?
        <Grid container mt='20px' spacing={2.5}>
          {
            dishList.map((d) =>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={d.nID}>
                <DishesCard products={products} setOrderCount={setOrderCount} activeCateg={activeCateg} orderCount={orderCount} value={d} selectedDate={value} cutoff={showCutoffOnly && isCutoffDish(d, cutoff) ? cutoff : null} />

              </Grid>)
          }

        </Grid>
        :
        <Box mt='20px' height='calc(100vh - 530px)' alignItems='center' display='flex' justifyContent='center' >
          <Typography variant='t24_700' color='grey.500' >
            Dishes for this vendor currently not Available!
          </Typography>
        </Box>
      }

      </Box>
  )
}

export default Dishes
